export { RibbonComponent } from './ribbon.component';



// WEBPACK FOOTER //
// C:/wxj/LicAuth/05開発/LicAuth.angularjs/src/app/shared/layout/ribbon/index.ts